import { useApiGet } from "@skanska/vsa-client-auth";
import { useEffect, useState } from "react";
import { ApiEndpoints } from "../models/ApiEndpoints";
import {
  missingImagePlaceholder,
  resolveImageDataOrPlaceholder,
} from "../services/MissingImagePlaceholder";
import { Image } from "../models/Image";

interface ActivityImageData {
  src: string;
  title: string;
}

export function useActivityImageData(
  imageId: string
): ActivityImageData | undefined {
  const { data, error } = useApiGet<Image>(
    `${ApiEndpoints.ImageCurrent}/${imageId}`,
    null,
    ["activity-image", { imageId }]
  );
  const [resolvedImageData, setResolvedImageData] =
    useState<ActivityImageData>();

  useEffect(() => {
    if (error || data === undefined) {
      return;
    }

    let cancelled = false;

    resolveImageDataOrPlaceholder(data.webUrl).then((imageData) => {
      if (!cancelled) {
        setResolvedImageData({ src: imageData, title: data.title });
      }
    });

    return () => {
      cancelled = true;
    };
  }, [data, error]);

  if (error) {
    return { src: missingImagePlaceholder, title: "" };
  }

  if (data === undefined) {
    return undefined;
  }

  return resolvedImageData;
}
